import { render, staticRenderFns } from "./PreviewStep.vue?vue&type=template&id=68d20224&"
import script from "./PreviewStep.vue?vue&type=script&lang=js&"
export * from "./PreviewStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports